import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiClient } from '../api/api';
import "./AdminDashboard.css";
import GradientHeading from './GradientHeading';

const AdminDashboard = () => {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    apiClient.get('/admin/all-shops')
      .then(response => {
        setShops(Array.isArray(response.data) ? response.data : []);
      })
      .catch(err => {
        console.error("Error fetching shops:", err);
        setError("Failed to load shops.");
      })
      .finally(() => setLoading(false));
  }, []);

  const filteredShops = shops.filter(shop => {
    const q = search.toLowerCase();
    return (
      (shop.shop_name || '').toLowerCase().includes(q) ||
      (shop.tiktok_shop_id || '').toLowerCase().includes(q)
    );
  });

  const statusColor = (status) => {
    if (!status || status === 'unknown') return '#6b7280';
    const s = status.toLowerCase();
    if (s.includes('activ')) return '#10b981';
    if (s.includes('pend')) return '#f59e0b';
    return '#6b7280';
  };

  return (
    <div className="admin-dashboard modern-admin-dashboard">
      <div className="dashboard-header">
        <GradientHeading>
          <h1>Shops</h1>
        </GradientHeading>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search by shop name or Shop ID..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="search-bar modern-search-bar"
          />
        </div>
      </div>

      {error && (
        <div style={{ padding: '16px', color: '#ef4444', background: '#1a1a1a', borderRadius: '8px', marginBottom: '16px' }}>
          {error}
        </div>
      )}

      <div className="table-wrapper">
        <table className="admin-dashboard-table modern-table">
          <thead>
            <tr>
              <th>Shop Name</th>
              <th>Shop ID</th>
              <th>Status</th>
              <th>Scraper</th>
              <th>Last Scraped</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="no-data">Loading shops...</td>
              </tr>
            ) : filteredShops.length === 0 ? (
              <tr>
                <td colSpan={6} className="no-data">
                  {search ? 'No shops match your search.' : 'No shops found.'}
                </td>
              </tr>
            ) : (
              filteredShops.map((shop) => (
                <tr key={shop.id} className="user-row">
                  <td className="username-cell">{shop.shop_name}</td>
                  <td className="brand-cell" style={{ fontSize: '12px', color: '#9ca3af' }}>
                    {shop.tiktok_shop_id || '—'}
                  </td>
                  <td>
                    <span style={{
                      fontSize: '11px',
                      fontWeight: '600',
                      color: statusColor(shop.activation_status),
                      textTransform: 'capitalize',
                    }}>
                      {shop.activation_status || 'unknown'}
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span style={{ color: shop.scraper_enabled ? '#10b981' : '#6b7280', fontSize: '12px' }}>
                      {shop.scraper_enabled ? '✓ On' : 'Off'}
                    </span>
                  </td>
                  <td style={{ fontSize: '11px', color: '#9ca3af' }}>
                    {shop.last_scraped ? new Date(shop.last_scraped).toLocaleDateString() : '—'}
                  </td>
                  <td className="action-cell">
                    <Link to={`/admin/shop/${shop.id}`} className="view-shop-btn">
                      <span role="img" aria-label="shop">🔎</span> View Shop
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {!loading && filteredShops.length > 0 && (
          <div style={{ padding: '12px 0', fontSize: '12px', color: '#6b7280' }}>
            {filteredShops.length} of {shops.length} shops
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
